const OLD_FORMAT = /^[A-Z]{3}\d{4}$/
const MERCOSUL_FORMAT = /^[A-Z]{3}\d[A-Z]\d{2}$/

export const PLATE_ERROR = 'Placa inválida. Use ABC1234 ou ABC1D23.'

/** Maiúscula e sem hífen: `jer-3232` vira `JER3232`. */
export function normalizePlate(input: string): string {
  return input.toUpperCase().replace(/[^A-Z0-9]/g, '')
}

export function isValidPlate(plate: string): boolean {
  return OLD_FORMAT.test(plate) || MERCOSUL_FORMAT.test(plate)
}

/** `JER3232` vira `JER-3232`, do jeito que o cartão da placa mostra. */
export function formatPlate(plate: string): string {
  const normalized = normalizePlate(plate)
  if (normalized.length !== 7) return normalized
  return `${normalized.slice(0, 3)}-${normalized.slice(3)}`
}
